<div class="prices">
    <!-- block dates selected -->
    <router-outlet></router-outlet>
 </div>